import Vue from 'vue'
import axios from 'axios'
import router from '../router/'
import config from '@/config/config.js'
import { setStore, getStore, removeStore } from '@/utils/utils.js'

axios.defaults.baseURL = config.baseURL
axios.defaults.timeout = 20000
axios.defaults.headers = {
    //"Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    "Content-Type": "application/json"
}

//刷新token的请求方法
const getRefreshToken = (isAdmin) => {
    let data = {
        refreshToken: isAdmin ? getStore('refreshTokenAdmin') : getStore('refreshToken')
    };
    let refreshToken = (isAdmin ? '/pisces' : '/alexstrasza') + '/user/refreshToken'
    //qs的使用主要是因为该接口需要表单提交的方式传数据，具体使用方法自行百度
    return axios.post(refreshToken, data);
}

//添加一个请求拦截器
axios.interceptors.request.use(axiosconfig => {

    //在请求发送之前做一些事
    let deviceID = getStore('deviceId')
    axiosconfig.headers.deviceId = deviceID
    axiosconfig.headers.cType = "PC"
    let flk = ''
    if (axiosconfig.url.includes('/alexstrasza/')) {
        axiosconfig.headers.appName = config.appNameAdmin
        flk = getStore('authTokenAdmin')
    } else {
        axiosconfig.headers.appName = config.appName
        flk = getStore('flk')
    }
    axiosconfig.headers.JWTToken = flk
    // 认证令牌

    return axiosconfig
}, error => {
    Vue.prototype.$message({
        showClose: true,
        message: error,
        type: 'error'
    });
    return Promise.reject(error)
})

//添加一个返回拦截器
axios.interceptors.response.use(response => {
    //对响应数据做些事
    if (response.data.code === 1002) {
        let config = response.config;
        let isAdmin = config.url.includes('/alexstrasza/')
        return getRefreshToken(isAdmin)
            .then(function (res) {
                if (res.data.code === 1000) {
                    let data = res.data.data
                    if (isAdmin) {
                        setStore('authTokenAdmin', data.flk)
                        setStore('refreshTokenAdmin', data.refreshToken)
                    } else {
                        setStore('flk', data.flk)
                        setStore('refreshToken', data.refreshToken)
                    }
                    //修改原请求的token
                    config.headers.JWTToken = data.flk
                    /*这边不需要baseURL是因为会重新请求url
                     *url中已经包含baseURL的部分了
                     *如果不修改成空字符串，会变成'api/api/xxxx'的情况*/
                    config.baseURL = '';
                    //重新请求
                    return axios(config).then(
                        (responsedata) => {
                            console.log("重发上一次请求")
                            return responsedata
                        }
                    ).catch(
                        (response) => {
                            console.log("未渲染成功")
                            return response
                        });
                } else {
                    Vue.prototype.$message({ showClose: true, message: '超时退出', type: 'warning' });
                    window.location.href = clearLoginInfo()
                    return { data: { code: '1001' } }
                }
            });

    } else if (response.data.code === 1001) {
        Vue.prototype.$message({ showClose: true, message: '超时退出', type: 'warning' });
        setTimeout(() => {
            // window.location.href = clearLoginInfo()
            router.push({
                path: clearLoginInfo()
            })
        }, 2000)

        return { data: { code: '1001' } }
    } else {
        return response
    }
}, error => {
    // 下面是接口回调的satus ,因为我做了一些错误页面,所以都会指向对应的报错页面
    if (error.response.status === 403) {
        router.push({
            path: "/error/403"
        });
    }
    if (error.response.status === 500) {
        router.push({
            path: "/error/500"
        });
    }
    if (error.response.status === 502) {
        router.push({
            path: "/error/502"
        });
    }
    if (error.response.status === 404) {
        // router.push({
        //     path: "/error/404"
        // });
    }
    return Promise.resolve(error.response)
})

//错误处理
function errorState(response) {
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
        return response
        // 如果不需要除了data之外的数据，可以直接 return response.data
    } else {
        Vue.prototype.$message({
            showClose: true,
            message: '网络异常',
            type: 'error'
        });
    }

}

function successState(res) {
    //统一判断后端返回的错误码
    if (res.data.code == '9999') {
        Vue.prototype.$message({
            showClose: true,
            message: '9999-服务器内部异常/网络异常',
            type: 'error'
        });
    } else if (res.data.code == '1003') {
        //添加登录密码错误次数限制
        let login_error_info = localStorage.getItem('login_error_info')
        if (login_error_info) {
            login_error_info = JSON.parse(login_error_info)
            if(Number(login_error_info.nums) == 3){
                login_error_info.nums = 1
            }else{
                login_error_info.nums = Number(login_error_info.nums) + 1
            }
            login_error_info.datetime = new Date().getTime()
            localStorage.setItem('login_error_info', JSON.stringify(login_error_info))
        }else{
            localStorage.setItem('login_error_info', JSON.stringify({ nums: 1, datetime: new Date().getTime() }))
        } 
    }
}

const httpServer = (opts, data) => {
    let httpDefaultOpts = { //http默认配置
        ...opts,
        method: opts.method || "post",
        url: opts.url
    }

    if (opts.method == 'get') {
        httpDefaultOpts.params = data
    } else {
        httpDefaultOpts.data = data
    }

    let promise = new Promise(function (resolve, reject) {
        axios(httpDefaultOpts).then(
            (res) => {
                console.log('#####', res)
                successState(res)
                resolve(res)
            }
        ).catch(
            (response) => {
                errorState(response)
                reject(response)
            }
        )
    })
    return promise
}

function clearLoginInfo() {
    let retUrl = '/?goLogin'
    if (getStore('loginAdmin')) {
        retUrl = '/admin/login'
        removeStore('authTokenAdmin')
        removeStore('refreshTokenAdmin')
        removeStore('loginAdmin')
    } else {
        removeStore('flk')
        removeStore('refreshToken')
        removeStore('loginUser')
    }
    return retUrl
}

export default httpServer